import MDinput from '@/components/MDinput';
import { validatorRequire, validatorRequireNumber } from '@/utils/validators';
import Select from '@/components/DSE/Select';

export function getFormDefinition(vue) {
  return {
    description: {
      type: MDinput,
      defaultValue: '',
      props: {
        maxlength: 16,
        required: true
      },
      rules: [{ validator: validatorRequire }]
    },
    countryID: {
      type: Select,
      defaultValue: null,
      props: {
        caption: 'common.country',
        valueField: 'id',
        labelField: 'name',
        loading: vue.$store.getters['country/isLoading'],
        options: vue.$store.getters['country/loadedItems'],
        required: true
      },
      rules: [{ validator: validatorRequireNumber }]
    }
  };
}

export default getFormDefinition;

export function createItemFromFormData(vue, form) {
  return form;
}

export function createFormDataFromItem(vue, item) {
  return item;
}
